module.exports = __webpack_public_path__ + "static/media/test11_1.228b949b.png";